<div class="dialog-container" [dir]="_translate.currentLang === 'ar' ? 'rtl' : 'ltr'">
  <h1 mat-dialog-title class="text-center"> {{ 'SUBSCRIPTION_SETTINGS.GET_STARTED' | translate }}
  </h1>
  <div mat-dialog-content style="min-height: 40px"> {{'SUBSCRIPTION_SETTINGS.ENABLE_CONFIRMATION' | translate}} </div>
  <div mat-dialog-actions align="end">
    <button mat-button class="dialog-cancel" (click)="save(false)">{{'COMMON.CANCEL'|translate}}</button>
    <button mat-flat-button color="primary" (click)="save(true)"> {{'COMMON.CONFIRM' |translate}}
    </button>
  </div>
</div>